import { render, staticRenderFns } from "./bscCustomer.vue?vue&type=template&id=f318d604"
import script from "./bscCustomer.vue?vue&type=script&lang=js"
export * from "./bscCustomer.vue?vue&type=script&lang=js"
import style0 from "./bscCustomer.vue?vue&type=style&index=0&id=f318d604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports